export default {"src":"/_next/static/media/uk.740244c4.svg","height":17,"width":26,"blurWidth":0,"blurHeight":0};